import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchMasterSession } from "../../redux/slices/masterSessionSlice";
import { fetchUserSession } from "../../redux/slices/userSessionSlice";
import { fetchUserByUid } from "../../redux/slices/userSlice";
import { fetchMasterByPhone } from "../../redux/slices/masterSlice";
import { getJwtToken } from "../../Utils/authStorage";

const AppInitializer = ({ children }) => {
    const dispatch = useDispatch();
    const didRun = useRef(false);

    useEffect(() => {
        if (didRun.current) return;
        didRun.current = true;

        const restore = async () => {
            const token = getJwtToken();
            // console.log("[AppInitializer] JWT в localStorage:", token ? "есть" : "НЕТ");

            // ── 1. Клиентская сессия ──────────────────────────────
            const userResult = await dispatch(fetchUserSession());
            // console.log("[AppInitializer] fetchUserSession:", userResult.type, userResult.payload);

            if (fetchUserSession.fulfilled.match(userResult)) {
                const uid = userResult.payload?.uid;
                const phone = userResult.payload?.phone;
                if (uid) dispatch(fetchUserByUid(uid));
                if (phone) dispatch(fetchMasterByPhone(phone));
                return;
            }

            // ── 2. Мастер-сессия ──────────────────────────────────
            const masterResult = await dispatch(fetchMasterSession());
            // console.log("[AppInitializer] fetchMasterSession:", masterResult.type, masterResult.payload);
        };

        restore();
    }, [dispatch]);

    return children;
};

export default AppInitializer;